var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [_vm.isLoading ? _c("Loading") : _vm._e()], 1),
      _vm._m(0),
      _c("div", { staticClass: "cal-container" }, [
        _c(
          "div",
          { staticClass: "simple-cal-container", attrs: { id: "dummyId" } },
          [
            _c(
              "no-ssr",
              [
                _c("calendar-view", {
                  staticClass: "theme-default isHovered",
                  attrs: {
                    "show-date": _vm.showDate,
                    events: _vm.wholeMonthMsList,
                    currentPeriodLabel: _vm
                      .$moment(_vm.showDate)
                      .format("MMM-YYYY")
                  },
                  on: {
                    "click-date": _vm.setShowDate,
                    "click-event": function($event) {
                      _vm.popUpEventModal($event)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function(ref) {
                        var headerProps = ref.headerProps
                        return _c("calendar-view-header", {
                          attrs: { "header-props": headerProps },
                          on: { input: _vm.setShowDate }
                        })
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._m(1)
      ]),
      _c("module-session-list", {
        on: { refreshMsList: _vm.initModuleSessionList }
      }),
      _c(
        "div",
        [
          _c(
            "b-modal",
            { ref: "moduleSessionBookingModal" },
            [
              _c("template", { slot: "modal-header" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.moduleSessionBookingModalData.moduleName) +
                    " - Seat Left: " +
                    _vm._s(
                      _vm.moduleSessionBookingModalData.seatTotal -
                        _vm.moduleSessionBookingModalData.seatTaken
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(
                "\n        Time: " +
                  _vm._s(
                    this.$moment(
                      _vm.moduleSessionBookingModalData.sessionTimeRaw,
                      [
                        "DD/MM/YYYY HH:mm",
                        "DD-MM-YYYY HH:mm",
                        _vm.$moment.ISO_8601
                      ]
                    ).format("DD-MM-YYYY HH:mm")
                  ) +
                  " "
              ),
              _c("br"),
              _vm._v(
                "\n        Language: " +
                  _vm._s(_vm.moduleSessionBookingModalData.language) +
                  " "
              ),
              _c("br"),
              _c(
                "div",
                {
                  staticClass: "w-100",
                  attrs: { slot: "modal-footer" },
                  slot: "modal-footer"
                },
                [
                  _vm.$store.state.authUser.flag != "Admin" &&
                  _vm.$store.state.authUser.flag != "Trn" &&
                  (Number(
                    _vm.moduleSessionBookingModalData.sessionTime -
                      Number(_vm.$moment().format("DD-MM-YYYY HH:mm"))
                  ) <=
                    3600 * 24 ||
                    _vm.moduleSessionBookingModalData.seatTotal -
                      _vm.moduleSessionBookingModalData.seatTaken <=
                      0)
                    ? _c(
                        "b-button",
                        {
                          staticClass: "float-left",
                          attrs: {
                            variant: "success",
                            disabled: "",
                            to: {
                              path:
                                "mainPage/" +
                                _vm.moduleSessionBookingModalData.id
                            }
                          }
                        },
                        [_vm._v("\n            Book\n          ")]
                      )
                    : _c(
                        "b-button",
                        {
                          staticClass: "float-left",
                          attrs: {
                            variant: "success",
                            to: {
                              path:
                                "mainPage/" +
                                _vm.moduleSessionBookingModalData.id
                            }
                          }
                        },
                        [_vm._v("\n            Book\n          ")]
                      ),
                  _c(
                    "div",
                    { staticClass: "float-right" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _vm.$store.state.authUser.flag === "Admin"
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "warning", size: "sm" },
                                      on: { click: _vm.showEditPanel }
                                    },
                                    [_vm._v("Edit\n                ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("b-col")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "b-modal",
            {
              ref: "editModuleSessionModal",
              attrs: { size: "lg", title: "Edit this module session" }
            },
            [
              _c("EditMsModalPanel", {
                on: { updateModuleSessionInfo: _vm.updateModuleSessionInfo }
              }),
              _c(
                "div",
                { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
                [_vm._v("\n          ----------------------\n        ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cal-container" }, [
      _c("div", { staticClass: "notice-container" }, [
        _c("h2", { staticStyle: { color: "#184167" } }, [
          _vm._v("Click on the calendar date for more details")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cal-legend" }, [
      _c(
        "span",
        { staticStyle: { "background-color": "darkgreen", color: "white" } },
        [_vm._v("Green: Seat Left ≥ 15 ")]
      ),
      _vm._v(" |\n        "),
      _c("span", { staticStyle: { "background-color": "yellow" } }, [
        _vm._v("Yellow: Seat Left ≥ 6-14")
      ]),
      _vm._v(" |\n        "),
      _c(
        "span",
        { staticStyle: { "background-color": "darkred", color: "white" } },
        [_vm._v("Red: Seat Left ≤ 5")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0802cb24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0802cb24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/mainPage/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0802cb24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/mainPage/index.vue
// module chunks = 6